/**
 * Canonical auth storage for PurchasePuffin web.
 *
 * Single shared instance of `@puffin-core/auth-token-storage` so that
 * token lifecycle operations coordinate across authService, AuthContext,
 * and any future API client or interceptor.
 *
 * @module features/auth/services/authStorage
 */

import { createAuthTokenStorage } from '@puffin-core/auth-token-storage';
import { StorageService } from '@puffin-core/storage';

import { adminFlagLastReadStore } from '../../../core/featureFlags/flagLastReadStore';

/**
 * Canonical purchase-web auth storage instance (localStorage, namespace `purchase-auth`). Signing out also clears the
 * admin app's last good feature-flag read (UAT-BLOCKERS D1 item 11), on every path that ends the session.
 */
export const authStorage = createAuthTokenStorage('purchase-auth', {
  storage: StorageService.getInstance(),
  clearOnSignOut: [adminFlagLastReadStore.clear],
});

/** Endpoint the refresh coordinator POSTs to when exchanging refresh tokens. */
export const REFRESH_ENDPOINT = '/api/v1/auth/tenant/refresh';
